function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 9.167v4a1.334 1.334 0 0 1-1.333 1.333H3.333A1.334 1.334 0 0 1 2 13.167V5.833A1.333 1.333 0 0 1 3.333 4.5h4M10 2.5h4v4M6.667 9.833L14 2.5",
  stroke: "#1063CD",
  strokeWidth: 1.292,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgOutside = props => React.createElement("svg", _extends({
  width: 16,
  height: 17,
  fill: "none"
}, props), _ref);

export default SvgOutside;